<h2>Salon Chain Mapping</h2>

<div class="px-2 py-3 contents h-full max-h-80" *ngIf="isLoadSalonChainMappingGridDataSource">
    <div class="flex pb-4 justify-start">
        <dx-check-box [value]="false" text="Include deactivated Salon Chain Mapping items" class="pr-2" (onValueChanged)="extraFilteringOptionsChange('Active', $event)"></dx-check-box>
    </div>
    <div class="mapping-grid-container shadow-lg">
        <div class="mt-2 h-full">
            <dx-data-grid
                #salonChainMappingDataGrid
                id="salonChainMappingDataGrid"
                [allowColumnResizing]="true"
                [columnResizingMode]="'widget'"
                [allowColumnReordering]="true"
                [dataSource]="salonChainMappingGridDataSource"
                [showBorders]="true"
                [columnAutoWidth]="true"
                [remoteOperations]="true"
                [hoverStateEnabled]="true"
                [(selectedRowKeys)]="salonChainMappingSelectedRowMap"
                (onSelectionChanged)="selectionMappingDataChangedHandler()"
                (onContentReady)="onReady($event)"
                (onContextMenuPreparing)="salonChainMappingDataGridContextMenu($event)"
                keyExpr="SalonChainMappingId"
            >
                <dxo-state-storing
                        [enabled]="true"
                        type="custom"
                        [customLoad]="loadMappingState"
                        [customSave]="saveMappingState">
                </dxo-state-storing>
                <dxo-load-panel
                        [enabled]="false"
                        shadingColor="rgba(0,0,0,0.4)"
                        [showIndicator]="true"
                        [showPane]="true"
                        [shading]="true">
                </dxo-load-panel>
                <dxo-filter-panel [visible]="true"></dxo-filter-panel>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-pager
                        [visible]="true"
                        [allowedPageSizes]="[5, 10, 25, 50, 100]"
                        displayMode="compact"
                        [showPageSizeSelector]="true"
                        [showNavigationButtons]="false"
                >
                </dxo-pager>
                <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
                <dxo-selection mode="single"></dxo-selection>
                <dxo-column-chooser [enabled]="true" mode="dragAndDrop"></dxo-column-chooser>

                <dxi-column dataField="SalonChainMappingId" [allowHeaderFiltering]="false" [width]="180"></dxi-column>
                <dxi-column caption="Action" [allowHeaderFiltering]="false" cellTemplate="action" alignment="center"></dxi-column>
                <dxi-column dataField="SourceSalonChainUid">
                    <dxo-header-filter [dataSource]="sourceSalonChainUidHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="SourceSalonChainName">
                    <dxo-header-filter [dataSource]="sourceSalonChainNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="DataProviderCode">
                    <dxo-header-filter [dataSource]="dataProviderCodeHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="MappingModeName" caption="Mapping Mode Name" [allowHeaderFiltering]="false" [allowFiltering]="false">
                </dxi-column>
                <dxi-column dataField="MappingModeId" caption="Mapping Mode" [alignment]="'left'">
                    <dxo-header-filter [dataSource]="mappingModeNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column caption="Data auditing">
                    <dxi-column dataField="CreatedByUserFullNameSortableOrPrincipalName" caption="Created by" [visible]="false">
                        <dxo-header-filter [dataSource]="createdByHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="CreatedOn" caption="Create on" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                        <dxo-header-filter [dataSource]="createdOnHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="ModifiedByUserFullNameSortableOrPrincipalName" caption="Modified by" >
                        <dxo-header-filter [dataSource]="modifiedByHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="ModifiedOn" caption="Modified on" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                        <dxo-header-filter [dataSource]="modifiedOnHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="ReviewedByUserFullNameSortableOrPrincipalName" caption="Reviewed by" [visible]="false">
                        <dxo-header-filter [dataSource]="reviewedByHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="ReviewedOn" caption="Reviewed on" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                        <dxo-header-filter [dataSource]="reviewedOnHeaderDataSource"></dxo-header-filter>
                    </dxi-column>
                </dxi-column>
                <dxi-column caption="Current mapping">
                    <dxi-column dataField="SalonChainId" [allowHeaderFiltering]="false">
                    </dxi-column>
                    <dxi-column dataField="SalonChainName">
                        <dxo-header-filter [dataSource]="mappingSalonChainName"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="SalonChainWebsite" [visible]="false">
                        <dxo-header-filter [dataSource]="mappingSalonChainWebsite"></dxo-header-filter>
                    </dxi-column>
                    <dxi-column dataField="SalonChainComment" [visible]="false">
                        <dxo-header-filter [dataSource]="mappingSalonChainComment"></dxo-header-filter>
                    </dxi-column>
                </dxi-column>
                <dxi-column dataField="Active" caption="Is Active" [visible]="false"></dxi-column>
                <div *dxTemplate="let action of 'action'">
                    <dx-button class="mr-1" icon="fas fa-ban fa-1x" hint="Omit" [disabled]="action?.data?.MappingModeId == 3" (onClick)="omit(action?.data?.SalonChainMappingId)"></dx-button>
                    <dx-button class="mr-1" icon="far fa-bookmark fa-1x" hint="Save" [disabled]="action?.data?.MappingModeId == 2" (onClick)="save(action?.data?.SalonChainMappingId)"></dx-button>
                    <dx-button
                            id="btnAccept"
                            *ngIf="action?.data?.ModifiedByUserId <= 0 && action?.data?.MappingModeId == 0"
                            class="mr-1"
                            icon="fa fa-check fa-1x"
                            hint="Accept"
                            (onClick)="accept(action?.data?.SalonChainMappingId)"
                    ></dx-button>
                    <dx-button
                            id="btnReview"
                            *ngIf="action?.data?.modifiedByUserId > 0 && action?.data?.modifiedByUserId != currentUser?.UserId && action?.data?.ReviewedByUserId == -1"
                            icon="fas fa-check-double"
                            hint="Review"
                            (onClick)="review(action?.data?.SalonChainMappingId)"
                    ></dx-button>
                    <dx-button *ngIf="currentUser?.UserRoleId > 1 && action?.data?.Active" icon="fas fa-trash-alt fa-1x" hint="Deactivate" (onClick)="deactivate(action?.data?.SalonChainMappingId)"></dx-button>
                    <dx-button *ngIf="currentUser?.UserRoleId > 1 && !action?.data?.Active" icon="fas fa-trash-alt fa-1x" hint="Reactivate" (onClick)="reactivate(action?.data?.SalonChainMappingId)"></dx-button>
                </div>
                <dxo-paging [pageSize]="5"></dxo-paging>
            </dx-data-grid>
        </div>
    </div>
</div>

<div class="py-3 block h-full" *ngIf="isLoadSalonChainMasterGridDataSource">
<!--    *ngIf="isLoadSalonChainMasterGridDataSource"-->
    <div class="mapping-grid-container shadow-lg">
        <div class="flex">
            <button type="button" class="btn btn-light btn-create-product" (click)="createSalonChain()"><i class="fa fa-plus" aria-hidden="true"></i></button>
        </div>
        <div class="mt-2 h-full">
            <dx-data-grid
                #salonChainMasterDataGrid
                id="salonChainMasterDataGrid"
                [allowColumnResizing]="true"
                [columnResizingMode]="'widget'"
                [allowColumnReordering]="true"
                [dataSource]="salonChainMasterGridDataSource"
                [showBorders]="true"
                [columnAutoWidth]="true"
                [remoteOperations]="true"
                [hoverStateEnabled]="true"
                [(selectedRowKeys)]="salonChainMasterSelectedRowMap"
                (onSelectionChanged)="selectionMasterDataChangedHandler()"
                (onContentReady)="onReadyMasterGrid($event)"
                (onContextMenuPreparing)="salonChainMasterDataGridContextMenu($event)"
                keyExpr="SalonChainId"
            >
                <dxo-state-storing
                        [enabled]="true"
                        type="custom"
                        [customLoad]="loadMasterState"
                        [customSave]="saveMasterState">
                </dxo-state-storing>
                <dxo-load-panel
                        [enabled]="false"
                        shadingColor="rgba(0,0,0,0.4)"
                        [showIndicator]="true"
                        [showPane]="true"
                        [shading]="true">
                </dxo-load-panel>
                <dxo-filter-panel [visible]="true"></dxo-filter-panel>
                <dxo-filter-row [visible]="true"></dxo-filter-row>
                <dxo-pager
                        [visible]="true"
                        [allowedPageSizes]="[5, 10, 25, 50, 100]"
                        displayMode="compact"
                        [showPageSizeSelector]="true"
                        [showNavigationButtons]="false"
                >
                </dxo-pager>
                <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
                <dxo-selection mode="single"></dxo-selection>
                <dxo-column-chooser [enabled]="true" mode="dragAndDrop"></dxo-column-chooser>

                <dxi-column dataField="SalonChainId" [allowHeaderFiltering]="false" [width]="180"></dxi-column>
                <dxi-column caption="Action" [allowHeaderFiltering]="false" cellTemplate="action" alignment="center"></dxi-column>

                <dxi-column dataField="Name">
                    <dxo-header-filter [dataSource]="salonChainMasterNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="Website">
                    <dxo-header-filter [dataSource]="salonChainMasterWebsiteHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="Comment">
                    <dxo-header-filter [dataSource]="salonChainMasterCommentHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CreatedByUserFullNameSortableOrPrincipalName" caption="Created by" [visible]="false">
                    <dxo-header-filter [dataSource]="createdByMasterHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CreatedOn" caption="Create on" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="createdOnMasterHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedByUserFullNameSortableOrPrincipalName" caption="Modified by" >
                    <dxo-header-filter [dataSource]="modifiedByMasterHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedOn" caption="Modified on" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="modifiedOnMasterHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedByUserFullNameSortableOrPrincipalName" caption="Reviewed by" [visible]="false">
                    <dxo-header-filter [dataSource]="reviewedByMasterHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedOn" caption="Reviewed on" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="reviewedOnMasterHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <div *dxTemplate="let action of 'action'">
                    <dx-button
                            class="mr-1"
                            icon="fas fa-map-marker-alt fa-1x"
                            hint="Map"
                            (onClick)="map(action?.data?.SalonChainId)"></dx-button>
                    <dx-button
                            *ngIf="action.data.SalonChainId > 0"
                            class="mr-1"
                            hint="Edit"
                            icon="fas fa-edit fa-1x"
                            (onClick)="editSalonChainMasterData(action?.data)"></dx-button>
                </div>
                <dxo-paging [pageSize]="5"></dxo-paging>
            </dx-data-grid>
        </div>
    </div>
</div>
